import { Injectable } from '@angular/core';
import { AuthResponse } from '@app/reducers/auth/auth.model';
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomerIOService {
  public analytics: AnalyticsBrowser;

  public initCustomerIo(authResponse?: AuthResponse) {
    if (!this.analytics) {
      this.analytics = AnalyticsBrowser.load(
        {
          writeKey: environment.customerIoWriteKey,
          cdnURL: 'https://cdp-eu.customer.io',
        },
        {
          integrations: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Customer.io In-App Plugin': {
              siteId: environment.customerIoSiteId,
            },
          },
        },
      );
    }

    if (authResponse?.User) {
      const { id, email, first_name: firstName, last_name: lastName } = authResponse.User;
      this.analytics.identify(id, {
        email,
        firstName,
        lastName,
      });
    }
  }

  public resetUser() {
    this.analytics?.reset();
  }
}
